import type { Permission, User } from '@/api/types'

/**
 * True when the user has every listed permission (AND), matching the
 * backend's requirePermission. No permissions listed → always true.
 */
export function hasPermission(user: User | null, ...permissions: Permission[]): boolean {
  if (!user) return false

  return permissions.every((permission) => user.permissions.includes(permission))
}
